import enumeration from "./enumeration";

const Validation = {
  REQUIRED: "Required",
  MAXLENGTH: "Maxlength",
  MINLENGTH: "Minlength",
};

export default enumeration(Validation);
